import { render, staticRenderFns } from "./px-global-error.vue?vue&type=template&id=d2541a9a&scoped=true&"
import script from "./px-global-error.vue?vue&type=script&lang=ts&"
export * from "./px-global-error.vue?vue&type=script&lang=ts&"
import style0 from "./px-global-error.vue?vue&type=style&index=0&id=d2541a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2541a9a",
  null
  
)

export default component.exports